module.exports = __webpack_public_path__ + "img/loader.35fe976e.svg";